module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/payout_providers/hm-logo-ca73e30d2fa160d48fc6dfb7ecf917b6.svg";